
(function(){
  'use strict';

  function parseVariants(root,key){
    var el=root.querySelector('[data-model-json="'+key+'"]');
    if(!el)return [];
    try{return JSON.parse(el.textContent||'[]');}catch(e){return [];}
  }

  function normalize(s){
    return String(s||'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
  }

  function findVariant(variants,size){
    var target=normalize(size);
    var aliases={
      'twin xl':['twin xl','twin extra long','txl'],
      'queen':['queen'],
      'king':['king'],
      'split king':['split king']
    }[target]||[target];

    return variants.find(function(v){
      var text=normalize([v.title].concat(v.options||[]).join(' '));
      return aliases.some(function(alias){
        return text===alias || text.indexOf(alias)!==-1;
      });
    })||null;
  }

  function formatMoney(cents,format){
    if(window.Shopify && typeof window.Shopify.formatMoney==='function'){
      try{return window.Shopify.formatMoney(cents,format);}catch(e){}
    }
    return '$'+(Number(cents||0)/100).toLocaleString(undefined,{
      minimumFractionDigits:0,maximumFractionDigits:2
    });
  }

  function init(root){
    if(!root || root.dataset.pbCompareInit==='true')return;
    root.dataset.pbCompareInit='true';

    var moneyFormat=root.getAttribute('data-money-format')||'${{amount}}';
    var models={
      essential:parseVariants(root,'essential'),
      performance:parseVariants(root,'performance'),
      premier:parseVariants(root,'premier')
    };

    var sizeSelect=root.querySelector('[data-size-select]');
    var traySelect=root.querySelector('[data-tray-size]');

    function setPrice(selector,text,unavailable){
      root.querySelectorAll(selector).forEach(function(el){
        el.textContent=text;
        el.classList.toggle('is-unavailable',!!unavailable);
      });
    }

    function updateSize(size){
      if(sizeSelect)sizeSelect.value=size;
      if(traySelect)traySelect.value=size;

      root.querySelectorAll('[data-card-size-label],[data-table-size-label]').forEach(function(el){
        el.textContent=size;
      });

      ['essential','performance','premier'].forEach(function(key){
        var v=findVariant(models[key],size);
        var available=!!(v && v.available);
        var label=available ? formatMoney(v.price,moneyFormat) : 'Not available';

        setPrice('[data-price="'+key+'"]',label,!available);
        setPrice('[data-tray="'+key+'"]',label,!available);
        setPrice('[data-table="'+key+'"]',label,!available);
      });
    }

    if(sizeSelect){
      sizeSelect.addEventListener('change',function(){updateSize(sizeSelect.value);});
    }
    if(traySelect){
      traySelect.addEventListener('change',function(){updateSize(traySelect.value);});
    }

    root.querySelectorAll('.tabs button[data-group]').forEach(function(btn){
      btn.addEventListener('click',function(){
        root.querySelectorAll('.tabs button[data-group]').forEach(function(b){b.classList.remove('active');});
        btn.classList.add('active');
        var group=btn.getAttribute('data-group');

        root.querySelectorAll('[data-group-row],[data-rowgroup]').forEach(function(row){
          var show=group==='all' ||
            row.getAttribute('data-group-row')===group ||
            row.getAttribute('data-rowgroup')===group;
          row.style.display=show?'':'none';
        });
      });
    });

    updateSize(root.getAttribute('data-default-size')||'Queen');
  }

  function initAll(){
    document.querySelectorAll('[data-pb-compare-root]').forEach(init);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initAll);
  }else{
    initAll();
  }

  document.addEventListener('shopify:section:load',function(e){
    var root=e.target.querySelector('[data-pb-compare-root]');
    if(root)init(root);
  });
})();
